module.exports = __webpack_public_path__ + "static/media/DiscGuard Terms & Conditions.6d6f0c46.pdf";